import * as React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Theme, WithStyles} from "@material-ui/core";
import {bindActions, mockTheme, WithActions} from '../utils/utils';
import {IStore} from '../store';
import {connect} from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {RouteData} from '../components/routeSelector';
import  {RaceAbmState} from '../components/race/raceAdd';

import {RaceActions} from '../store/race/race-actions';
import Paper from '@material-ui/core/Paper';
import {IRaceStore} from '../store/race/race-reducer';
import {Planning} from '../api/model';
import { ConfigData } from '../config';
import { RouteComponentProps } from 'react-router-dom';
import { NotificationActions } from 'src/store/notification/notification-actions';
import { BranchActions } from 'src/store/branch';
import { DriverActions } from 'src/store/driver';
import PlanificacionMultiAdd from 'src/components/planificacion-multiday/planificacionMultiAdd';


const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    add: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },

    routeSelector: {
        width: '100%',
        height: '100%'
    },
    buttons: {
        marginLeft: 'auto',
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface PlanificacionProps extends WithStyles<keyof typeof classesType>, WithActions<RaceActions>,RouteComponentProps<any> {
    race: IRaceStore;
    config: ConfigData;
    notificationActions: NotificationActions;
    branchActions: BranchActions;
    driverActions: { actions: DriverActions; notification: any };
    user?: any;
}

interface PlanificacionState {
    abmState: RaceAbmState
}

class Planificacion extends React.Component<PlanificacionProps, PlanificacionState> {

    constructor(props: PlanificacionProps) {
        super(props);

        this.state = {
            abmState: 'edit'
        };

        this.handleNewLocation = this.handleNewLocation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleNewLocation(data: RouteData) {
        this.setState({
            ...this.state,
        })
    }

    handleSubmit(data: Planning) {

        this.setState({
            abmState: 'adding',
        });
        this.props.actions.addPlanificationMultiDay(data,this.props.history);
        // this.props.history.push();
    }

    componentDidUpdate(prevProps: PlanificacionProps) {
        // Verificar si cambió el estado de la carrera
        if (prevProps.race.current !== this.props.race.current) {
            if (this.props.race.current.data && this.props.race.current.data.type) {
                this.setState({
                    abmState: 'added',
                });
                // Mostrar notificación de éxito
                const notificationActions = this.props.notificationActions as any;
                if (notificationActions && notificationActions.notification && notificationActions.notification.addSuccess) {
                    notificationActions.notification.addSuccess('¡Carrera creada exitosamente!');
                }
            }
            if (this.props.race.current.error) {
                this.setState({
                    abmState: 'error',
                });
                
                // Usar la estructura correcta: notificationActions.notification.addError
                const notificationActions = this.props.notificationActions as any;
                if (notificationActions && notificationActions.notification && notificationActions.notification.addError) {
                    notificationActions.notification.addError(
                        `Error al crear la carrera: ${this.props.race.current.error.message || this.props.race.current.error}`,
                        'Revisa la consola para más detalles',
                        8000
                    );
                } else {
                    alert(`Error al crear la carrera: ${this.props.race.current.error.message || this.props.race.current.error}`);
                }
            }
        }
    }


    render() {

        return (
            <Grid container spacing={24}>
                <Grid item md={12} lg={12}>
                    <Paper elevation={11} className={this.props.classes.add}>
                        <Typography variant="title">Planificación de rutas</Typography>
                        <PlanificacionMultiAdd handleAdd={this.handleSubmit}
                                 error={this.props.race.current.error}
                                 state={this.state.abmState}
                                 config={this.props.config}
                                 notification={this.props.notificationActions}
                                 branchActions={this.props.branchActions}
                                 driverActions={this.props.driverActions}
                                 user={this.props.user}
                                 />
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: PlanificacionProps) => ({
    ...ownProps,
    race: state.race,
    config: state.config.data,
    user: state.auth.user,
});

const mapDispatchToProps = (dispatch: any) => ({
    ...bindActions(RaceActions)(dispatch),
    notificationActions: bindActions(NotificationActions)(dispatch),
    branchActions: bindActions(BranchActions)(dispatch),
    driverActions: bindActions(DriverActions)(dispatch)
});

const connected = connect(mapStateToProps, mapDispatchToProps)(Planificacion as any);
const styled = withStyles(styles as any)(connected);

export default styled;



// WEBPACK FOOTER //
// ./src/pages/planificacionMulti.tsx